import React, { useEffect, useState } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  ScrollRestoration,
  useLocation,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CLEAR_REGISTER } from "./Actions/types";
import jwt from "jwt-decode";
import { useMediaQuery } from "react-responsive";
import { imgUrl } from "./config/api";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import Home from "./Pages/Home";
import Panel from "./Middleware Panel/Panel";
import Menu from "./Middleware Panel/Menu";
import Slideshow from "./Middleware Panel/Slideshow";
import Banner from "./Middleware Panel/Banner";
import Curtain from "./Custom Pages/Curtain";
import Product from "./Product Pages/Product";
import HeaderFooter from "./Components/HeaderFooter";
import Models from "./Middleware Panel/Models";
import CustomCurtain from "./Custom Pages/CustomCurtain";
import HeaderWithOutlet from "./Components/HeaderWithOutlet";
import Basket from "./Pages/Basket";
import Checkout from "./Pages/Checkout";
import NoHeaderNoFooter from "./Components/NoHeaderNoFooter";
import Projects from "./Pages/Projects";
import RegisterLogin from "./Pages/RegisterLogin";
import AccountLayout from "./Pages/AccountLayout";
import Settings from "./Pages/Settings";
import AddressBook from "./Pages/AddressBook";
import OrderHistory from "./Pages/OrderHistory";
import OrderDetails from "./Pages/OrderDetails";
import Reset from "./Pages/Reset";
import ConfirmEmail from "./Pages/ConfirmEmail";
import PageItems from "./Middleware Panel/PageItems";
import CurtainSelection from "./Custom Pages/CurtainSelection";
import Products from "./Product Pages/Products";
import ProductsTowel from "./Product Pages/ProductsTowel";
import ReadyMadeDraperyItem from "./Product Pages/ReadyMadeDraperyItem";
import ReadyMadeFabricItem from "./Product Pages/ReadyMadeFabricItem";
import Rod from "./Product Pages/Rod";
import Favorite from "./Pages/Favorite";
import ReadyMyProduct from "./Product Pages/ReadyMadeProduct";
import ReadyMadeTowel from "./Product Pages/ReadyMadeTowel";
import OneCurtain from "./Product Pages/OneCurtain";
import NecessaryOrdering from "./Product Pages/NecessaryOrdering";
import Collection from "./Product Pages/Collection";
import ReadyMadeShadeItem from "./Product Pages/ReadyMadeShadeItem";
import NewPanelPage from "./NewPanel/NewPanelPage";
import OrdersPage from "./NewPanel/OrdersPage";
import PlaceholderPage from "./NewPanel/PlaceholderPage";
import GroupPage from "./Middleware Panel/GroupPage";
import PagePanel from "./Middleware Panel/PagePanel";
import PagePanelTest from "./Middleware Panel/PagePanelTest";
import EditGroupPage from "./Middleware Panel/EditGroupPage";

const router = createBrowserRouter([{ path: "*", Component: Root }]);

export default function App({ t }) {
  return <RouterProvider router={router} />;
}

function Root({ t }) {
  const dispatch = useDispatch();
  const [user1, setuser] = useState({
    name: "",
    pass: "",
    success: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isDoopsalta2Domain, setIsDoopsalta2Domain] = useState(false);
  const location = useLocation();
  const hiddenLoginPaths = [
    "/en/Curtain/dk/0326/Page-ID/17",
    "/en/Curtain/dk/0326/Page-ID/18",
    "/en/Curtain/dk/0326/Page-ID/19",
    "/en/Curtain/dk/0326/1/Page-ID/20",
    "/en/Curtain/dk/0326/1/Page-ID/21",
    "/en/Curtain/dk/0326/1/Page-ID/22",
    "/en/Curtain/dk/0326/1/Page-ID/23",
    "/en/Curtain/dk/0326/Page-ID/23",
    "/fa/Curtain/dk/0326/Page-ID/17",
    "/fa/Curtain/dk/0326/Page-ID/18",
    "/fa/Curtain/dk/0326/Page-ID/19",
    "/fa/Curtain/dk/0326/1/Page-ID/20",
    "/fa/Curtain/dk/0326/1/Page-ID/21",
    "/fa/Curtain/dk/0326/1/Page-ID/22",
    "/fa/Curtain/dk/0326/1/Page-ID/23",
    "/fa/Curtain/dk/0326/Page-ID/23",
  ];

  const isHiddenLoginPath = hiddenLoginPaths.includes(location.pathname);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const hostWithPort = window.location.host.toLowerCase();
      const isMainDomain = hostWithPort.includes("store") || hostWithPort === "localhost:3001";
      setIsDoopsalta2Domain(isMainDomain);
    }

    const currentLang = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    document.body.classList.remove("language-en", "language-fa");
    document.body.classList.add(`language-${currentLang}`);
  }, []);

  const inputsHandler = (e) => {
    setuser((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleLogin = (e) => {
    e.preventDefault();
    const { name, pass } = user1;
    let ok = false;
    if (!isDoopsalta2Domain) {
      ok = name === "atlas" && pass === "ap20251404";
    } else {
      ok =
        (name === "Valiasr" && pass === "Va1332") ||
        (name === "Dodange" && pass === "Do1398") ||
        (name === "Atlaspood" && pass === "Ap1405");
    }
    if (ok) setuser((prev) => ({ ...prev, success: true }));
  };

  const { isLoggedIn, isRegistered, user } = useSelector((state) => state.auth);
  const [showPage, setShowPage] = useState(false);
  const [roles, setRoles] = useState([]);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });

  useEffect(() => {
    setShowPage(true);
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      let tempRoles = jwt(user["access_token"])[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
      ];
      if (tempRoles && tempRoles.length > 0) {
        setRoles(tempRoles);
      } else {
        setRoles(["User"]);
      }
    } else {
      setRoles([]);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (isRegistered) {
      setTimeout(() => {
        dispatch({
          type: CLEAR_REGISTER,
        });
      }, 5000);
    }
  }, [isRegistered]);

  return (
    <>
      {showPage && (
        <div className="App">
          <div
            className={
              isTabletOrMobile
                ? isPortrait
                  ? "page_container mobile_page_container portrait_page_container"
                  : "page_container mobile_page_container landscape_page_container"
                : "page_container desktop_page_container"
            }
          >
            {!user1.success &&
              !isHiddenLoginPath &&
              (isDoopsalta2Domain ? (
                <div className="login_test_container-box">
                  <div className="login_test login_test-fa">
                    <div className="login_container_img">
                      <img
                       
                         src={imgUrl("//Content/Images/WebSiteMenu/49492_Photo.jpg")}
                        className="login_img"
                        alt="login_img"
                      />
                    </div>
                    <div className="box-userName-pass-login">
                      <div className="login_container_test-fa login_page_container ">
                        <h1 className="login_title_new" style={{ fontSize: "1.375rem" }}>
                          ورود
                        </h1>

                        <input
                          type="text"
                          placeholder="*نام کاربری"
                          className="form-control form-control-new2 form-control-fa"
                          name="name"
                          value={user1.name}
                          onChange={inputsHandler}
                          autoComplete="off"
                        />

                        <div className="login_password_field_wrap">
                          <input
                            type={showPassword ? "text" : "password"}
                            placeholder="*پسورد"
                            className="form-control form-control-password form-control-new2 form-control-fa"
                            name="pass"
                            value={user1.pass}
                            onChange={inputsHandler}
                            autoComplete="off"
                          />
                          <button
                            type="button"
                            className="login_password_toggle_btn"
                            aria-label={showPassword ? "پنهان کردن پسورد" : "نمایش پسورد"}
                            onClick={() => setShowPassword((prev) => !prev)}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </button>
                        </div>

                        <div className="login_btn_container">
                          <button
                            type="button"
                            className="login_btn btn btn-new-dark login_btn_new"
                            onClick={handleLogin}
                          >
                            وارد شوید
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="login_test_container-box">
                  <div className="login_test">
                    <div className="box-userName-pass-login">
                      <div className="login_container_test login_page_container ">
                        <h1 className="login_title_new">LOGIN</h1>

                        <input
                          type="text"
                          placeholder="Username*"
                          className="form-control form-control-new2"
                          name="name"
                          value={user1.name}
                          onChange={inputsHandler}
                          autoComplete="off"
                        />

                        <div className="login_password_field_wrap">
                          <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Password*"
                            className="form-control form-control-password form-control-new2"
                            name="pass"
                            value={user1.pass}
                            onChange={inputsHandler}
                            autoComplete="off"
                          />
                          <button
                            type="button"
                            className="login_password_toggle_btn"
                            aria-label={showPassword ? "Hide password" : "Show password"}
                            onClick={() => setShowPassword((prev) => !prev)}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </button>
                        </div>

                        <div className="login_btn_container">
                          <button
                            type="button"
                            className="login_btn btn btn-new-dark login_btn_new"
                            onClick={handleLogin}
                          >
                            SIGN IN
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="login_container_img">
                      <img
                        
                        src={imgUrl("//Content/Images/WebSiteMenu/49492_Photo.jpg")}
                        className="login_img"
                        alt="login_img"
                      />
                    </div>
                  </div>
                </div>
              ))}

            {(user1.success || isHiddenLoginPath) && (
              <Routes>
                <Route path="/en" element={<HeaderFooter />}>
                  <Route path="" element={<Home />} />
                  <Route path="Curtain/:catID" element={<Curtain />} />
                  <Route path="Curtain/:catID/Selection" element={<CurtainSelection />} />
                  <Route path="Ready-Made-Drapery/:catID" element={<Products />} />
                  <Route
                    path="Ready-Made-Drapery/:catID/:productID/:designID"
                    element={<OneCurtain />}
                  />
                  <Route path="ready-made-shade/:catID" element={<Products />} />
                  <Route path="ready-made-shade/:catID/filters/" element={<Products />} />
                  <Route
                    path="ready-made-shade/:catID/:productID/:designID"
                    element={<ReadyMadeDraperyItem />}
                  />
                  <Route path="ready-made-fabric/:catID" element={<Products />} />
                  <Route path="ready-made-fabric/:catID/filters/" element={<Products />} />
                  <Route
                    path="ready-made-fabric/:catID/:productID/:designID"
                    element={<ReadyMadeFabricItem />}
                  />
                  <Route path="Rods/:catID" element={<Products />} />
                  <Route path="Rods/:catID/:productID/:designID" element={<Rod />} />
                  <Route path="ready-made-product/:catID" element={<Products />} />
                  <Route
                    path="ready-made-product/:catID/:productID/:designID"
                    element={<ReadyMyProduct />}
                  />
                  {/* productsTowel  => Products */}
                  <Route path="collections/:catID" element={<Products />} />
                  <Route path="collections/:catID/filters/" element={<Products />} />
                  <Route
                    path="collections/:catID/:productID/:designID"
                    element={<ReadyMadeTowel />}
                  />
                  {/* برای مجموعه شیدها */}
                  <Route path="collection-shade/:catID" element={<Products />} />
                  <Route path="collection-shade/:catID/filters/" element={<Products />} />
                  <Route
                    path="collection-shade/:catID/:productID/:designID"
                    element={<ReadyMadeShadeItem />}
                  />
                  {/* برای ال پرودات جهت تست دوتای زیر */}
                  <Route path="collection/:catID" element={<Collection />} />
                  <Route path="collection/:catID/filters/" element={<Collection />} />
                  <Route
                    path="collection/:catID/:productID/:designID"
                    element={<NecessaryOrdering />}
                  />
                  {/* تا اینجا */}
                  <Route path="Product/:catID" element={<Product />} />
                  <Route path="Basket" element={<Basket />} />
                  <Route path="Basket/:swatchOnly" element={<Basket />} />
                  <Route
                    path="User"
                    element={
                      isRegistered ? (
                        <Navigate replace to="/en/Account" />
                      ) : isLoggedIn ? (
                        <Navigate to="/en/Account/OrderHistory" />
                      ) : (
                        <RegisterLogin />
                      )
                    }
                  />
                  <Route path="User/NewUser" element={<Navigate replace to="/en/User" />} />
                  <Route path="User/Reset/:emailId/:resetId" element={<Reset />} />
                  <Route
                    path="Favorites"
                    element={isLoggedIn ? <Favorite /> : <Navigate replace to="/en/User" />}
                  />
                  <Route
                    path="Account"
                    element={isLoggedIn ? <AccountLayout /> : <Navigate replace to="/en/User" />}
                  >
                    <Route path="" element={<Settings />} />
                    <Route path="Projects" element={<Projects />} />
                    <Route path="AddressBook" element={<AddressBook />} />
                    <Route path="Favorites" element={<Favorite />} />
                    <Route path="OrderHistory" element={<OrderHistory />} />
                    <Route path="OrderDetails/:orderID" element={<OrderDetails />} />
                  </Route>
                </Route>
                <Route path="/fa" element={<HeaderFooter />}>
                  <Route path="" element={<Home />} />
                  <Route path="Curtain/:catID" element={<Curtain />} />
                  <Route path="Curtain/:catID/Selection" element={<CurtainSelection />} />
                  <Route path="Ready-Made-Drapery/:catID" element={<Products />} />
                  <Route
                    path="Ready-Made-Drapery/:catID/:productID/:designID"
                    element={<OneCurtain />}
                  />
                  <Route path="ready-made-shade/:catID" element={<Products />} />
                  <Route path="ready-made-shade/:catID/filters/" element={<Products />} />
                  <Route
                    path="ready-made-shade/:catID/:productID/:designID"
                    element={<ReadyMadeDraperyItem />}
                  />
                  <Route path="ready-made-fabric/:catID" element={<Products />} />
                  <Route path="ready-made-fabric/:catID/filters/" element={<Products />} />
                  <Route
                    path="ready-made-fabric/:catID/:productID/:designID"
                    element={<ReadyMadeFabricItem />}
                  />
                  <Route path="Rods/:catID" element={<Products />} />
                  <Route path="Rods/:catID/:productID/:designID" element={<Rod />} />
                  {/* برای مجموعه شیدها */}
                  <Route path="collection-shade/:catID" element={<Products />} />
                  <Route path="collection-shade/:catID/filters/" element={<Products />} />
                  <Route
                    path="collection-shade/:catID/:productID/:designID"
                    element={<ReadyMadeShadeItem />}
                  />
                  {/* برای ال پرودات جهت تست دوتای زیر */}
                  <Route path="collection/:catID" element={<Collection />} />
                  <Route path="collection/:catID/filters/" element={<Collection />} />
                  <Route
                    path="collection/:catID/:productID/:designID"
                    element={<NecessaryOrdering />}
                  />
                  {/* تا اینجا */}
                  <Route path="ready-made-product/:catID" element={<Products />} />
                  <Route
                    path="ready-made-product/:catID/:productID/:designID"
                    element={<ReadyMyProduct />}
                  />
                     {/* productsTowel  => Products */}
                  <Route path="collections/:catID" element={<Products />} />
                  <Route path="collections/:catID/filters/" element={<Products />} />
                  <Route
                    path="collections/:catID/:productID/:designID"
                    element={<ReadyMadeTowel />}
                  />
                  <Route path="Product/:catID" element={<Product />} />
                  <Route path="Basket" element={<Basket />} />
                  <Route path="Basket/:swatchOnly" element={<Basket />} />
                  <Route
                    path="User"
                    element={isLoggedIn ? <Navigate replace to="/fa/Account" /> : <RegisterLogin />}
                  />
                  <Route path="User/NewUser" element={<Navigate replace to="/fa/User" />} />
                  <Route path="User/Reset/:emailId/:resetId" element={<Reset />} />
                  <Route
                    path="Favorites"
                    element={isLoggedIn ? <Favorite /> : <Navigate replace to="/fa/User" />}
                  />
                  <Route
                    path="Account"
                    element={isLoggedIn ? <AccountLayout /> : <Navigate replace to="/fa/User" />}
                  >
                    <Route path="" element={<Settings />} />
                    <Route path="Projects" element={<Projects />} />
                    <Route path="AddressBook" element={<AddressBook />} />
                    <Route path="Favorites" element={<Favorite />} />
                    <Route path="OrderHistory" element={<OrderHistory />} />
                    <Route path="OrderDetails/:orderID" element={<OrderDetails />} />
                  </Route>
                </Route>

                <Route path="/en" element={<HeaderWithOutlet />}>
                  {/*<Route path="Curtain/:catID/:modelID" element={<CustomCurtain/>}/>*/}
                  <Route
                    path="Curtain/:catID/:modelID/Saved-Projects/:projectId/Page-ID/:websitePageItemId"
                    element={<CustomCurtain />}
                  />
                  <Route
                    path="Curtain/:catID/:modelID/:specialID/Saved-Projects/:projectId/Page-ID/:websitePageItemId"
                    element={<CustomCurtain />}
                  />
                  <Route
                    path="Curtain/:catID/:modelID/Bag-Projects/:editIndex/Page-ID/:websitePageItemId"
                    element={<CustomCurtain />}
                  />
                  <Route
                    path="Curtain/:catID/:modelID/:specialID/Bag-Projects/:editIndex/Page-ID/:websitePageItemId"
                    element={<CustomCurtain />}
                  />
                  <Route
                    path="Curtain/:catID/:modelID/Copy-Projects/:editIndex/Page-ID/:websitePageItemId"
                    element={<CustomCurtain />}
                  />
                  <Route
                    path="Curtain/:catID/:modelID/:specialID/Bag-Projects/:editIndex/Page-ID/:websitePageItemId"
                    element={<CustomCurtain />}
                  />
                  <Route
                    path="Curtain/:catID/:modelID/Page-ID/:websitePageItemId"
                    element={<CustomCurtain />}
                  />
                  <Route
                    path="Curtain/:catID/:modelID/:specialID/Page-ID/:websitePageItemId"
                    element={<CustomCurtain />}
                  />
                  <Route path="Checkout" element={<Checkout />} />
                  <Route path="Checkout/:swatchOnly" element={<Checkout />} />
                </Route>
                <Route path="/fa" element={<HeaderWithOutlet />}>
                  {/*<Route path="Curtain/:catID/:modelID" element={<CustomCurtain/>}/>*/}
                  <Route
                    path="Curtain/:catID/:modelID/Saved-Projects/:projectId/Page-ID/:websitePageItemId"
                    element={<CustomCurtain />}
                  />
                  <Route
                    path="Curtain/:catID/:modelID/:specialID/Saved-Projects/:projectId/Page-ID/:websitePageItemId"
                    element={<CustomCurtain />}
                  />
                  <Route
                    path="Curtain/:catID/:modelID/Bag-Projects/:editIndex/Page-ID/:websitePageItemId"
                    element={<CustomCurtain />}
                  />
                  <Route
                    path="Curtain/:catID/:modelID/:specialID/Bag-Projects/:editIndex/Page-ID/:websitePageItemId"
                    element={<CustomCurtain />}
                  />
                  <Route
                    path="Curtain/:catID/:modelID/Page-ID/:websitePageItemId"
                    element={<CustomCurtain />}
                  />
                  <Route
                    path="Curtain/:catID/:modelID/:specialID/Page-ID/:websitePageItemId"
                    element={<CustomCurtain />}
                  />
                  <Route path="Checkout" element={<Checkout />} />
                  <Route path="Checkout/:swatchOnly" element={<Checkout />} />
                </Route>

                <Route path="/en" element={<NoHeaderNoFooter />}>
                  <Route path="User/Activate/:activeId" element={<ConfirmEmail />} />
                </Route>
                <Route path="/fa" element={<NoHeaderNoFooter />}>
                  <Route path="User/Activate/:activeId" element={<ConfirmEmail />} />
                </Route>

                <Route
                  path="/admin/panel"
                  element={
                    roles.includes("WebsiteAdmin") ? <Panel /> : <Navigate replace to="/en" />
                  }
                >
                  <Route path="menu" element={<Menu />} />
                  <Route path="slideshow" element={<Slideshow />} />
                  <Route path="banner" element={<Banner />} />
                  <Route path="models" element={<Models />} />
                  <Route path="page-items" element={<PageItems />} />
                </Route>

                <Route
                  path="/admin/panel2/fa"
                  element={
                    roles.includes("WebsiteAdmin") ? (
                      <NewPanelPage language="fa" />
                    ) : (
                      <Navigate replace to="/fa" />
                    )
                  }
                >
                  <Route index element={<PlaceholderPage titleKey="dashboard" />} />
                  <Route path="menu" element={<PlaceholderPage titleKey="menu" />} />
                  <Route path="slideshow" element={<PlaceholderPage titleKey="slideShow" />} />
                  <Route path="banner" element={<PlaceholderPage titleKey="banner" />} />
                  <Route path="models" element={<PlaceholderPage titleKey="models" />} />
                  <Route path="page-items" element={<PageItems />} />
                  <Route path="group-page" element={<GroupPage />} />
                  <Route path="page-panel" element={<PagePanel />} />
                  <Route path="page-panel-test" element={<PagePanelTest />} />
                  <Route path="group-page/:groupID" element={<EditGroupPage />} />
                  <Route path="orders" element={<OrdersPage />} />
                  <Route path="page1" element={<PlaceholderPage titleKey="page1" />} />
                  <Route path="page2" element={<PlaceholderPage titleKey="page2" />} />
                  <Route path="page3" element={<PlaceholderPage titleKey="page3" />} />
                </Route>
                <Route
                  path="/admin/panel2/en"
                  element={
                    roles.includes("WebsiteAdmin") ? (
                      <NewPanelPage language="en" />
                    ) : (
                      <Navigate replace to="/en" />
                    )
                  }
                >
                  <Route index element={<PlaceholderPage titleKey="dashboard" />} />
                  <Route path="menu" element={<PlaceholderPage titleKey="menu" />} />
                  <Route path="slideshow" element={<PlaceholderPage titleKey="slideShow" />} />
                  <Route path="banner" element={<PlaceholderPage titleKey="banner" />} />
                  <Route path="models" element={<PlaceholderPage titleKey="models" />} />
                  <Route path="page-items" element={<PageItems />} />
                  <Route path="group-page" element={<GroupPage />} />
                  <Route path="page-panel" element={<PagePanel />} />
                  <Route path="page-panel-test" element={<PagePanelTest />} />
                  <Route path="group-page/:groupID" element={<EditGroupPage />} />
                  <Route path="orders" element={<OrdersPage />} />
                  <Route path="page1" element={<PlaceholderPage titleKey="page1" />} />
                  <Route path="page2" element={<PlaceholderPage titleKey="page2" />} />
                  <Route path="page3" element={<PlaceholderPage titleKey="page3" />} />
                </Route>
                {isDoopsalta2Domain ? (
                  <Route path="*" element={<Navigate replace to="/fa" />} />
                ) : (
                  <Route path="*" element={<Navigate replace to="/en" />} />
                )}
              </Routes>
            )}
          </div>
        </div>
      )}
      <ScrollRestoration getKey={(location) => location.pathname} />
    </>
  );
}
